<template>
  <grid horizontal="center">
    <grid-item>
      <vue-recaptcha
        v-if="recaptcha"
        ref="recaptcha"
        @verify="onVerify"
        @expired="onExpired"
        badge="inline"
        size="invisible"
        :sitekey="recaptcha.key"
      />
      <input
        type="hidden"
        hidden
        v-model="response"
        v-validate="validatorDefinitions.captcha"
      />
    </grid-item>
  </grid>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import VueRecaptcha from "vue-recaptcha";

export default {
  name: "captcha",
  components: { VueRecaptcha },
  props: ["value"],
  data() {
    return {
      response: null
    };
  },
  computed: {
    ...mapGetters("config", {
      recaptcha: "getRecaptcha"
    })
  },
  methods: {
    ...mapActions("config", {
      getRecaptchaData: "getRecaptchaData"
    }),
    onVerify(value) {
      this.response = value;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
      this.response = null;
    },
    onExecute() {
      try {
        this.$refs.recaptcha.execute();
      } catch (e) {}
    }
  },
  watch: {
    response(value) {
      this.$emit("input", value);
      this.$emit("verified");
    }
  },
  created() {
    if (!this.recaptcha) {
      this.getRecaptchaData();
    }

    if (!document.getElementById("googleRecaptcha")) {
      let googleRecaptcha = document.createElement("script");
      googleRecaptcha.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
      );
      googleRecaptcha.setAttribute("async", "");
      googleRecaptcha.setAttribute("id", "googleRecaptcha");
      googleRecaptcha.setAttribute("defer", "");

      document.head.appendChild(googleRecaptcha);
    }

    this.EventBus.$on(this.events.CAPTCHA_RESET, () => {
      this.$refs.recaptcha.reset();
    });

    this.EventBus.$on(this.events.CAPTCHA_EXECUTE, () => {
      this.onExecute();
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
